<template>
  <div class="full-height">
    <table-con :showBreadCrumb='0'>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">{{$t('mess.mess3')}}:</div>
            <div class="flex1">
              <el-input :placeholder="$t('mess.mess3')" clearable v-model="queryInfo.orderId" size="small"
                @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title" style="width:150px">{{$t('mess.mess4')}}:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.messageType" :placeholder="$t('mess.mess4')" size="small" clearable>
                <el-option v-for="item in messageTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">{{$t('mess.mess5')}}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('mess.mess6')">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">{{$t('mess.mess7')}}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('mess.mess6')">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
        </el-collapse>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 0}"
              @click="quickSearchList('',index = 0)">{{$t('mess.mess8')}}</el-button>
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 1}"
              @click="quickSearchList('0',index = 1)">{{$t('mess.mess9')}}<span class="lx-red">({{orderData.unReadNum}})</span>
            </el-button>
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 2}"
              @click="quickSearchList('1',index = 2)">{{$t('mess.mess10')}}</el-button>
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 3}"
              @click="quickSearchList('1',index = 3)">{{$t('mess.mess50')}}</el-button>
          </el-col>
          <el-col :span="18" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;float:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('mess.mess11')}}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{$t('mess.mess12')}}</el-button>
              <el-button class="search-btn btn-blue" @click="readAll">{{$t('mess.mess13')}}</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt="" @click="isActive = !isActive" >{{$t('search.expandPanel')}}</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive" >{{$t('search.retractPanel')}}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col" style="padding:10px;height:100%">
        <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="messageList" border
          height="550px">
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <el-table-column :label="$t('handle')" align="center" width="80">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button class="list-btn btn-green" @click="reply(scope.row)"
                  v-if="btnReplyFlag == scope.row.replyFlag&&scope.row.createUserName!='system'">
                  {{$t('mess.mess15')}}
                </el-button>
              </div>
              <div class="btn-row">
                <el-button class="list-btn btn-blue" @click="read(scope.row)" v-if="btnReadFlag ==scope.row.isRead">
                  {{$t('mess.mess10')}}
                </el-button>
              </div>
              <div class="btn-row">
                <el-button class="list-btn btn-blue" @click="handleDetail(scope.row)">
                  {{$t('detail')}}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="replyFlag" sortable :index="indexMethod" align="center" width="100" :label="$t('mess.mess16')">
            <template v-slot="scope">
              <span v-if="scope.row.replyFlag==1">{{ replyStatusShow(scope.row.replyFlag) }}</span>
              <span v-else-if="scope.row.isRead==1">{{ readStatusShow(scope.row.isRead) }}</span>
              <span v-else>{{ readStatusShow(scope.row.isRead) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="replyPicture" align="center" width="100" :label="$t('mess.mess17')">
            <template slot-scope="scope">
              <div v-for="item in getFileList(scope.row.replyPicture)" :key="item">
                <img @click="imgclick(item,true)" v-if="item&&item.length>0"
                     :src="item" alt="" class="list-image more-image" >
                <img v-else src="../../assets/images/default.png" alt="" class="list-image">
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="messageType" width="100" :label="$t('mess.mess18')">
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.messageType) }}
            </template>
          </el-table-column>
          <el-table-column prop="orderId" align="center" width="200" :label="$t('mess.mess19')">
            <template v-slot="scope">
              <el-link v-if="scope.row.messageType==1" @click="toOrderDetail(scope.row)" :underline="false">{{scope.row.orderId}}
              </el-link>
              <span v-else>{{scope.row.orderId}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" sortable align="center" :index="indexMethod" width="200" :label="$t('mess.mess20')">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column prop="remindingTitle" width="200" :label="$t('mess.mess21')">
          </el-table-column>
          <el-table-column :label="$t('mess.mess22')">
            <template v-slot="scope">
              <div v-html="scope.row.remindingContent"></div>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" :label="$t('mess.mess45')">
            <template v-slot="scope">
               <span v-for="item in getAttachment(scope.row.attachment)" :key="item">
              <a target="_blank" :href="item.url">{{item.name}}</a><br/>
            </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 回复 -->
    <el-dialog :title="$t('mess.mess15')" :visible.sync="replyDialogVisible" width="50%" @close="replyDialogClose">
      <el-form :model="replyInfo" :rules="rules" ref="replyInfo" label-width="130px" class="demo-replyInfo">
        <!-- 只读 -->
        <el-form-item :label="$t('mess.mess23')">
          <span>{{typeDetailShow(replyMessageInfo.messageType)}}</span>
        </el-form-item>
        <el-form-item :label="$t('mess.mess24')">
          <span>{{replyMessageInfo.orderId}}</span>
        </el-form-item>
        <!-- 回复内容 -->
        <el-form-item :label="$t('mess.mess25')" prop="remindingTitle">
          <el-input v-model="replyInfo.remindingTitle" maxlength="100"></el-input>
        </el-form-item>

        <el-form-item :label="$t('mess.mess26')" prop="remindingContent">
          <!-- <el-input v-model="replyInfo.remindingContent"></el-input> -->
          <quill-editor ref="text" v-model="replyInfo.remindingContent" :options="editorOption" />
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('mess.mess27')">
          <el-upload class="editor-slide-upload" :class="{hide:hideUploadEdit}"
            action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com" :data="imgDataObj" :multiple="true"
            :file-list="imgFileList" :show-file-list="true" list-type="picture-card" :on-remove="handleImgRemove"
            :on-success="handleImgSuccess" :before-upload="beforeImgUpload" :limit="3">
            <el-button size="small" type="primary" class="btn">{{$t('mess.mess28')}}</el-button>
          </el-upload>
        </el-form-item>
        <!-- 上传附件 -->
        <el-form-item :label="$t('createOrder.createOrder117')">
          <el-upload class="editor-slide-upload" :class="{hide:hideUploadEdit}" action="" :on-preview="handlePreview"
            :on-remove="handleRemove" :before-upload="beforeUploadFile" :before-remove="beforeRemove"
            :on-success="handleOrderInfo" multiple :show-file-list="true" :limit="3" :on-exceed="handleExceed"
            :file-list="attachmentList" :http-request="excelUploadRequest">
            <el-button class="search-btn btn-blue">{{ $t('createOrder.createOrder117') }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button class="form-btn btn-gray" @click="replyDialogClose">{{$t('cancel')}}</el-button>
        <el-button class="form-btn btn-blue" @click="replySave('replyInfo')">{{$t('confirm')}}</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog :title="$t('detail')" :visible.sync="detailFlag" width="1200px">
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="firstList" border>
        <el-table-column :label="$t('handle')" align="center" width="120">
          <template v-slot="scope">
            <div class="btn-row">
              <el-button class="list-btn btn-green" @click="reply(scope.row)"
                v-if="btnReplyFlag == scope.row.replyFlag&&scope.row.createUserName!='system'">
                {{$t('mess.mess15')}}
              </el-button>
            </div>
            <div class="btn-row">
              <el-button class="list-btn btn-blue" @click="read(scope.row)" v-if="btnReadFlag ==scope.row.isRead">
                {{$t('mess.mess10')}}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="replyFlag" :index="indexMethod" align="center" width="70" :label="$t('mess.mess16')">
          <template v-slot="scope">
            <span v-if="scope.row.replyFlag==1">{{ replyStatusShow(scope.row.replyFlag) }}</span>
            <span v-else-if="scope.row.isRead==1">{{ readStatusShow(scope.row.isRead) }}</span>
            <span v-else>{{ readStatusShow(scope.row.isRead) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remindingTitle" width="200" :label="$t('mess.mess21')">
        </el-table-column>
        <el-table-column width="300" :label="$t('mess.mess22')">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="replyPicture" align="center" :label="$t('mess.mess17')">
          <template slot-scope="scope">
            <div v-for="item in getFileList(scope.row.replyPicture)" :key="item">
              <img @click="imgclick(item,true)" v-if="item&&item.length>0"
                   :src="item" alt="" class="list-image more-image" >
              <img v-else src="../../assets/images/default.png" alt="" class="list-image">
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" :label="$t('mess.mess45')">
          <template v-slot="scope">
             <span v-for="item in getAttachment(scope.row.attachment)" :key="item">
              <a target="_blank" :href="item.url">{{item.name}}</a><br/>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" :label="$t('mess.mess19')">
          <template v-slot="scope">
            <el-link v-if="scope.row.messageType==1" @click="toOrderDetail(scope.row)" :underline="false">{{scope.row.orderId}}
            </el-link>
            <span v-else>{{scope.row.orderId}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" :index="indexMethod" :label="$t('mess.mess20')">
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="messageType" :label="$t('mess.mess18')">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="title">{{$t('mess.mess46')}}</div>
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="historyMessageList" border
        height="550px">
        <el-table-column prop="sender" width="120" align="center" :label="$t('mess.mess47')">
          <template v-slot="scope">
            <span v-if="scope.row.sender==1">{{$t('mess.mess49')}}</span>
            <span v-if="scope.row.sender==0">{{$t('mess.mess48')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="replyFlag" :index="indexMethod" align="center" width="70" :label="$t('mess.mess16')">
          <template v-slot="scope">
            <span v-if="scope.row.replyFlag==1">{{ replyStatusShow(scope.row.replyFlag) }}</span>
            <span v-else-if="scope.row.isRead==1">{{ readStatusShow(scope.row.isRead) }}</span>
            <span v-else>{{ readStatusShow(scope.row.isRead) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remindingTitle" width="200" :label="$t('mess.mess21')">
        </el-table-column>
        <el-table-column width="300" :label="$t('mess.mess22')">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="replyPicture" align="center" :label="$t('mess.mess17')">
          <template slot-scope="scope">
            <div v-for="item in getFileList(scope.row.replyPicture)" :key="item">
              <img @click="imgclick(item,true)" v-if="item&&item.length>0"
                   :src="item" alt="" class="list-image more-image" >
              <img v-else src="../../assets/images/default.png" alt="" class="list-image">
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" :label="$t('mess.mess45')">
          <template v-slot="scope">
              <span v-for="item in getAttachment(scope.row.attachment)" :key="item">
              <a target="_blank" :href="item.url">{{item.name}}</a><br/>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" :label="$t('mess.mess19')">
          <template v-slot="scope">
            <el-link v-if="scope.row.messageType==1" @click="toOrderDetail(scope.row)" :underline="false">{{scope.row.orderId}}
            </el-link>
            <span v-else>{{scope.row.orderId}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" :index="indexMethod" :label="$t('mess.mess20')">
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="messageType" :label="$t('mess.mess18')">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:right;margin-top:15px">
        <el-button class="form-btn btn-blue" @click="detailFlag=false">{{$t('confirm')}}</el-button>
      </div>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
  </div>
</template>

<script>
import Oss from '../../assets/js/oss.js'
import tableCon from '../../views/tableContainer'
const toolbarOptions = [
  ['bold'], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
]
export default {
  components: { tableCon },
  data () {
    return {
      isActive:false,
      curIndex: 0, // 默认选中第0个
      visible: false,
      detailFlag: false,
      imgurl: '',
      id: "",
      listObj: [],
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
          }
        }
      },
      historyMessageList: [],
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: '',
      },
      attachmentList: [],
      imgFileList: [],
      btnReplyFlag: 0,
      btnReadFlag: 0,
      replyInfo: {
        remindingContent: '',
        remindingTitle: '',
        replyPicture: '',
        imgFileListStr: '',
        attachment: ''
      },
      rules: {
        remindingTitle: [
          { required: true, message: this.$t('mess.mess29'), trigger: 'blur' }
        ],
        remindingContent: [
          { required: true, message: this.$t('mess.mess30'), trigger: 'blur' }
        ]
      },
      queryInfo: {
        createUserName: '',
        orderId: '',
        messageType: '',
        createTimeStart: '',
        createTimeEnd: '',
        replyFlag: '',
        isRead: '',
        pageSize: 10,
        pageNum: 1
      },
      hideUploadEdit: false,
      orderData: {
        unReadNum: 0,
        readNum: 0
      },
      dateRangeValue: [],
      replyMessageInfo: {},  //回复页面显示表格所在行内容
      splitDialogVisible: false,
      dialogVisible: false,
      messageTypeOptions: [
        {
          value: '1',
          label: this.$t('mess.mess31')
        }, {
          value: '2',
          label: this.$t('mess.mess32')
        }
      ],
      replyStatusOptions: [
        {
          value: '',
          label: this.$t('mess.mess33')
        },
        {
          value: '0',
          label: this.$t('mess.mess9')
        }, {
          value: '10',
          label: this.$t('mess.mess10')
        }, {
          value: '100',
          label: this.$t('mess.mess34')
        }
      ],
      messageList: [],
      firstList: [],
      replyDialogVisible: false,
      total: 0,
      statusFlag: '',
    }
  },
  methods: {
    getFileList (str) {
      if (str != null){
        return str.split(",");
      }
      return []
    },
    getAttachment (str){
      if (str != null && str.length > 0){
        return JSON.parse(str);
      }
      return []
    },
    handleRemove (file, fileList) {
      for (let i = 0; i < this.attachmentList.length; i++) {
        let attach = this.attachmentList[i];
        if (file.name == attach.name) {
          this.attachmentList.splice(i, 1)
        }
      }
    },
    async handleDetail (row) {
      this.id = row.id
      const { data: res } = await this.$http.get('cmUser/message/queryMessageInfo/' + row.id);
      this.historyMessageList = res.data
      let arr = []
      res.data.forEach(item => {
        if (item.id == this.id) {
          arr.push(item)
        }
      })
      this.firstList = arr
      this.detailFlag = true
    },
    handlePreview () {
      // console.log(file);
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `${this.$t('createOrder.createOrder91')}，${this.$t('createOrder.createOrder92')} ${files.length} ${this.$t('createOrder.createOrder93')}，${this.$t('createOrder.createOrder94')} ${files.length + fileList.length
        } ${this.$t('createOrder.createOrder93')}`
      );
    },
    beforeUploadFile (file) {
      const extension = file.name.substring(file.name.lastIndexOf('.'))
      // const size = file.size / 1024 / 1024
      if (extension !== '.xls' && extension !== '.xlsx' && extension !== '.pdf' && extension !== '.mp4') {
        this.$message.warning('只能上传excel和pdf文件')
        return false
      }

      // if (size > 10) {
      //   this.$message.warning('文件大小不得超过10M')
      // }
    },
    async excelUploadRequest (file) {
      let formdata = new FormData();
      formdata.append('file', file.file);
      const { data: res } = await this.$http.post('cmUser/message/uploadFile', formdata);
      if (res.code === 200) {
        let {fileName,filePath} = res.data;
        this.attachmentList.push({name:fileName,url:filePath})
      }
    },
    beforeRemove () {
      // return this.$confirm(`${this.$t('orderList.orderList107')} ${file.name}？`);
    },
    // 批量导入成功回调
    handleOrderInfo () {
      console.log('success')
      // console.log(data)
    },
    imgclick (url) {
      this.visible = true
      this.imgurl = url
    },
    showImgDialog () {
      this.imgDialogVisible = true;
    },
    handleImgSubmit () {
      var _this = this;
      const arr = Object.keys(_this.listObj).map(v => _this.listObj[v]);
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message(this.$t('mess.mess35'))
        return false
      } else {
        if (arr.length > 3) {
          _this.$message.error(this.$t('mess.mess52'));
          return false
        }
        _this.imgFileList = _this.imgFileList.concat(arr);
        var urlArr = [];
        _this.imgFileList.forEach(el => {
          urlArr.push(el.url);
        })
        _this.replyInfo.replyPicture = urlArr.toString();
        _this.$emit('successCBK', arr);
        _this.listObj = {};
        _this.imgDialogVisible = false;
      }
      if (_this.attachmentList.length>0){
        _this.replyInfo.attachment = JSON.stringify(this.attachmentList);
      }else{
        _this.replyInfo.attachment = ''
      }
      return true
    },
    handleImgRemove (file) {
      Oss.imgRemove(file, this.listObj);
      this.hideUploadEdit = false
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleImgSuccess (response, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
      this.hideUploadEdit = true
    },
    beforeImgUpload (file) {
      console.log(file);
      const _self = this;
      const fileName = file.uid;
      console.log(fileName);
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http.get('aliyun/oss/policy').then(response => {
          var num = "";   //定义编号
          for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
          {
            num += Math.floor(Math.random() * 10);
          }
          num = new Date().getTime() + num;  //时间戳，用来生成编号。
          _self.imgDataObj.policy = response.data.data.policy;
          _self.imgDataObj.signature = response.data.data.signature;
          _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
          _self.imgDataObj.key = response.data.data.dir + '/inBox/' + num + '${filename}';
          _self.imgDataObj.dir = response.data.data.dir + '/inBox';
          _self.imgDataObj.host = response.data.data.host;
          _self.imgDataObj.timeStamp = num;
          file.timeStamp = num
          Oss.imgCompress(file, this.listObj, resolve, reject)
        }).catch(err => {
          console.log(err)
          reject(false)
        })
      })
    },
    handleCurrentChange (newPage) {    //分页
      this.queryInfo.pageNum = newPage;
      this.getMessageList();
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getMessageList();
    },
    orderDateRange () {   //搜索时间

    },
    replySave (formName) {    //保存回复内容按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addReply(this.queryInfo.id);
          this.replyDialogVisible = false;
          this.btnReplyFlag == 0;
        } else {
          this.$message.error(this.$t('mess.mess37'));
          return false;
        }
      });
    },
    clearReplyForm () {   //回复弹窗的取消按钮
      this.initReplyForm();
      this.replyDialogVisible = false;
    },
    initReplyForm () {   //初始化回复弹窗的内容
      this.replyInfo = {
        remindingContent: '',
        remindingTitle: '',
        replyPicture: ''
      };
    },
    async addReply (id) {    //添加回复
      if (!this.handleImgSubmit()) {
        return false
      }
      this.id = id
      var url = 'cmUser/message/reply';
      const { data: res } = await this.$http.post(url, this.replyInfo);
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.getMessageList();
      this.getStatisticalNum();
      if (this.detailFlag) {
        const { data: res } = await this.$http.get('cmUser/message/queryMessageInfo/' + this.id);
        this.historyMessageList = res.data
        let arr = []
        res.data.forEach(item => {
          if (item.id == this.id) {
            arr.push(item)
          }
        })
        this.firstList = arr
      }
    },
    searchList () {    //查询
      this.queryInfo.pageNum = 1;
      this.queryInfo.isRead = '';
      this.queryInfo.replyFlag = '';
      console.log(this.statusFlag);
      if (this.statusFlag == '0') {
        this.queryInfo.isRead = '0';
      } else if (this.statusFlag == 10) {
        this.queryInfo.isRead = '1';
      } else if (this.statusFlag == 100) {
        this.queryInfo.replyFlag = '1';
      }
      this.getMessageList();
      this.getStatisticalNum();
    },
    quickSearchList (val, index) {
      this.curIndex = index
      this.queryInfo.pageNum = 1;
      if (index == 3) {
        this.queryInfo.replyFlag = val;
        this.queryInfo.isRead = '';
      } else {
        this.queryInfo.isRead = val;
        this.queryInfo.replyFlag = '';
      }

      this.getMessageList();
      this.getStatisticalNum();
    },
    async getMessageList () {   //获取信息列表
      const { data: res } = await this.$http.get('cmUser/message/inList', { params: this.queryInfo });
      res.data.list.forEach(item => {
        if (item.url) {
          item.url.split(',').forEach(citem => {
            if (item.remindingContent.includes(citem)) item.remindingContent = item.remindingContent.replace(citem, `<a href="${citem}" target="_blank">${citem}</a>`)
          })
        }
      })
      this.messageList = res.data.list;
      this.total = res.data.total;
    },
    async getStatisticalNum () {      //获取
      const { data: res } = await this.$http.get("cmUser/message/getInStatisticalNum", { params: this.queryInfo });
      this.orderData = res.data;
    },
    queryInfoClear () {    //清空
      this.queryInfo = {
        createTimeStart: '',
        createTimeEnd: '',
        orderId: '',
        userName: '',
        isRead: '',
        replyFlag: '',
        pageSize: 10,
        pageNum: 1
      }
      this.statusFlag = '';
      this.dateRangeValue = [];
    },
    typeDetailShow (status) {
      switch (status) {
        case '1':
          return this.$t('mess.mess31')
          break;
        case '2':
          return this.$t('mess.mess32')
          break;
      }
    },
    replyStatusShow (status) {
      switch (status) {
        case '1':
          return this.$t('mess.mess34')
          break;
        default:
          return this.$t('mess.mess38')
          break;
      }
    },
    readStatusShow (status) {
      switch (status) {
        case '1':
          return this.$t('mess.mess10')
          break;
        default:
          return this.$t('mess.mess9')
          break;
      }
    },
    async read (row) {    //已读
      var url = 'cmUser/message/readOne';
      const { data: res } = await this.$http.post(url, { id: row.id });
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.getMessageList();
      this.getStatisticalNum();
      this.btnReadFlag == row.isRead;
      if (this.detailFlag) {
        const { data: res } = await this.$http.get('cmUser/message/queryMessageInfo/' + this.id);
        this.historyMessageList = res.data
        let arr = []
        arr.push(res.data[0])
        this.firstList = arr
      }
    },
    async readAll () {    //全部已读
      var url = 'cmUser/message/readAll';
      const { data: res } = await this.$http.post(url, {});
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.getMessageList();
      this.getStatisticalNum();
      this.btnReadFlag = 0;
    },
    reply (row) {     //回复
      this.handleImgSubmit();
      this.replyDialogVisible = true;
      this.attachmentList = []
      this.imgFileList = []
      this.hideUploadEdit = false
      this.replyMessageInfo = row;
      this.replyInfo = {
        id: row.id
      };
    },
    replyDialogClose () {    //关闭回复弹窗
      console.log('close');
      this.replyDialogVisible = false;
    },
    toOrderDetail (row) {
      if (row.orderId.indexOf('R') != -1 || row.orderId.indexOf('C') != -1) { //R出现或者C出现
        this.$router.push({     //充值记录
          name: 'RechargeList',
          query: {
            rechargeNo: row.orderId
          }
        })
      } else {                  //订单详情
        this.$router.push({
          name: 'orderDetail',
          query: {
            id: row.orderId,
            isEdit: '0'
          }
        })
      }
    }
  },
  watch: {
    //监听时间选择器绑定值变化
    dateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.dateRangeValue) {
        this.dateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.dateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.dateRangeValue[0];
          this.queryInfo.createTimeEnd = this.dateRangeValue[1];
        }
      }

    }
  },
  created () {
    this.getStatisticalNum();
    this.getMessageList();
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}

.upload-container .editor-slide-upload {
  margin-bottom: 20px;
}
.title {
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  margin: 15px 0;
}
.btn {
  width: 120px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  height: auto;
  overflow: hidden;
}
.hide /deep/ .el-upload--picture-card {
  display: none;
}
/deep/ .breadcrumb-container {
  display: none;
}
</style>
